/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.projects.RunnerPhase
*/
export var RunnerPhase;
(function (RunnerPhase) {
    RunnerPhase["UNKNOWN"] = "UNKNOWN";
    RunnerPhase["PENDING"] = "PENDING";
    RunnerPhase["READY"] = "READY";
    RunnerPhase["FAILED"] = "FAILED";
    RunnerPhase["DISABLED"] = "DISABLED";
})(RunnerPhase || (RunnerPhase = {}));
//# sourceMappingURL=RunnerPhase.js.map